/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetCspOpportunityNarrativeRequest
 */
export interface SetCspOpportunityNarrativeRequest {
  /**
   *
   * @type {string}
   * @memberof SetCspOpportunityNarrativeRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof SetCspOpportunityNarrativeRequest
   */
  narrative?: string | null;
}

/**
 * Check if a given object implements the SetCspOpportunityNarrativeRequest interface.
 */
export function instanceOfSetCspOpportunityNarrativeRequest(
  value: object,
): value is SetCspOpportunityNarrativeRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  return true;
}

export function SetCspOpportunityNarrativeRequestFromJSON(
  json: any,
): SetCspOpportunityNarrativeRequest {
  return SetCspOpportunityNarrativeRequestFromJSONTyped(json, false);
}

export function SetCspOpportunityNarrativeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetCspOpportunityNarrativeRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    narrative: json["narrative"] == null ? undefined : json["narrative"],
  };
}

export function SetCspOpportunityNarrativeRequestToJSON(
  json: any,
): SetCspOpportunityNarrativeRequest {
  return SetCspOpportunityNarrativeRequestToJSONTyped(json, false);
}

export function SetCspOpportunityNarrativeRequestToJSONTyped(
  value?: SetCspOpportunityNarrativeRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    narrative: value["narrative"],
  };
}
